/**
 *  All possible timezone constants.
 */

import i18next from "src/i18n/config";

const AllTimezones = [
    "Africa/Abidjan",
    "Africa/Accra",
    "Africa/Addis_Ababa",
    "Africa/Algiers",
    "Africa/Asmara",
    "Africa/Bamako",
    "Africa/Bangui",
    "Africa/Banjul",
    "Africa/Bissau",
    "Africa/Blantyre",
    "Africa/Brazzaville",
    "Africa/Bujumbura",
    "Africa/Cairo",
    "Africa/Casablanca",
    "Africa/Ceuta",
    "Africa/Conakry",
    "Africa/Dakar",
    "Africa/Dar_es_Salaam",
    "Africa/Djibouti",
    "Africa/Douala",
    "Africa/El_Aaiun",
    "Africa/Freetown",
    "Africa/Gaborone",
    "Africa/Harare",
    "Africa/Johannesburg",
    "Africa/Juba",
    "Africa/Kampala",
    "Africa/Khartoum",
    "Africa/Kigali",
    "Africa/Kinshasa",
    "Africa/Lagos",
    "Africa/Libreville",
    "Africa/Lome",
    "Africa/Luanda",
    "Africa/Lubumbashi",
    "Africa/Lusaka",
    "Africa/Malabo",
    "Africa/Maputo",
    "Africa/Maseru",
    "Africa/Mbabane",
    "Africa/Mogadishu",
    "Africa/Monrovia",
    "Africa/Nairobi",
    "Africa/Ndjamena",
    "Africa/Niamey",
    "Africa/Nouakchott",
    "Africa/Ouagadougou",
    "Africa/Porto-Novo",
    "Africa/Sao_Tome",
    "Africa/Timbuktu",
    "Africa/Tripoli",
    "Africa/Tunis",
    "Africa/Windhoek",
    "America/Adak",
    "America/Anchorage",
    "America/Anguilla",
    "America/Antigua",
    "America/Araguaina",
    "America/Argentina/Buenos_Aires",
    "America/Argentina/Catamarca",
    "America/Argentina/ComodRivadavia",
    "America/Argentina/Cordoba",
    "America/Argentina/Jujuy",
    "America/Argentina/La_Rioja",
    "America/Argentina/Mendoza",
    "America/Argentina/Rio_Gallegos",
    "America/Argentina/Salta",
    "America/Argentina/San_Juan",
    "America/Argentina/San_Luis",
    "America/Argentina/Tucuman",
    "America/Argentina/Ushuaia",
    "America/Aruba",
    "America/Asuncion",
    "America/Atikokan",
    "America/Atka",
    "America/Bahia",
    "America/Bahia_Banderas",
    "America/Barbados",
    "America/Belem",
    "America/Belize",
    "America/Blanc-Sablon",
    "America/Boa_Vista",
    "America/Bogota",
    "America/Boise",
    "America/Buenos_Aires",
    "America/Cambridge_Bay",
    "America/Campo_Grande",
    "America/Cancun",
    "America/Caracas",
    "America/Catamarca",
    "America/Cayenne",
    "America/Cayman",
    "America/Chicago",
    "America/Chihuahua",
    "America/Coral_Harbour",
    "America/Cordoba",
    "America/Costa_Rica",
    "America/Creston",
    "America/Cuiaba",
    "America/Curacao",
    "America/Danmarkshavn",
    "America/Dawson",
    "America/Dawson_Creek",
    "America/Denver",
    "America/Detroit",
    "America/Dominica",
    "America/Edmonton",
    "America/Eirunepe",
    "America/El_Salvador",
    "America/Ensenada",
    "America/Fort_Nelson",
    "America/Fort_Wayne",
    "America/Fortaleza",
    "America/Glace_Bay",
    "America/Godthab",
    "America/Goose_Bay",
    "America/Grand_Turk",
    "America/Grenada",
    "America/Guadeloupe",
    "America/Guatemala",
    "America/Guayaquil",
    "America/Guyana",
    "America/Halifax",
    "America/Havana",
    "America/Hermosillo",
    "America/Indiana/Indianapolis",
    "America/Indiana/Knox",
    "America/Indiana/Marengo",
    "America/Indiana/Petersburg",
    "America/Indiana/Tell_City",
    "America/Indiana/Vevay",
    "America/Indiana/Vincennes",
    "America/Indiana/Winamac",
    "America/Indianapolis",
    "America/Inuvik",
    "America/Iqaluit",
    "America/Jamaica",
    "America/Jujuy",
    "America/Juneau",
    "America/Kentucky/Louisville",
    "America/Kentucky/Monticello",
    "America/Knox_IN",
    "America/Kralendijk",
    "America/La_Paz",
    "America/Lima",
    "America/Los_Angeles",
    "America/Louisville",
    "America/Lower_Princes",
    "America/Maceio",
    "America/Managua",
    "America/Manaus",
    "America/Marigot",
    "America/Martinique",
    "America/Matamoros",
    "America/Mazatlan",
    "America/Mendoza",
    "America/Menominee",
    "America/Merida",
    "America/Metlakatla",
    "America/Mexico_City",
    "America/Miquelon",
    "America/Moncton",
    "America/Monterrey",
    "America/Montevideo",
    "America/Montreal",
    "America/Montserrat",
    "America/Nassau",
    "America/New_York",
    "America/Nipigon",
    "America/Nome",
    "America/Noronha",
    "America/North_Dakota/Beulah",
    "America/North_Dakota/Center",
    "America/North_Dakota/New_Salem",
    "America/Ojinaga",
    "America/Panama",
    "America/Pangnirtung",
    "America/Paramaribo",
    "America/Phoenix",
    "America/Port_of_Spain",
    "America/Port-au-Prince",
    "America/Porto_Acre",
    "America/Porto_Velho",
    "America/Puerto_Rico",
    "America/Punta_Arenas",
    "America/Rainy_River",
    "America/Rankin_Inlet",
    "America/Recife",
    "America/Regina",
    "America/Resolute",
    "America/Rio_Branco",
    "America/Rosario",
    "America/Santa_Isabel",
    "America/Santarem",
    "America/Santiago",
    "America/Santo_Domingo",
    "America/Sao_Paulo",
    "America/Scoresbysund",
    "America/Shiprock",
    "America/Sitka",
    "America/St_Barthelemy",
    "America/St_Johns",
    "America/St_Kitts",
    "America/St_Lucia",
    "America/St_Thomas",
    "America/St_Vincent",
    "America/Swift_Current",
    "America/Tegucigalpa",
    "America/Thule",
    "America/Thunder_Bay",
    "America/Tijuana",
    "America/Toronto",
    "America/Tortola",
    "America/Vancouver",
    "America/Virgin",
    "America/Whitehorse",
    "America/Winnipeg",
    "America/Yakutat",
    "America/Yellowknife",
    "Antarctica/Casey",
    "Antarctica/Davis",
    "Antarctica/DumontDUrville",
    "Antarctica/Macquarie",
    "Antarctica/Mawson",
    "Antarctica/McMurdo",
    "Antarctica/Palmer",
    "Antarctica/Rothera",
    "Antarctica/South_Pole",
    "Antarctica/Syowa",
    "Antarctica/Troll",
    "Antarctica/Vostok",
    "Arctic/Longyearbyen",
    "Asia/Aden",
    "Asia/Almaty",
    "Asia/Amman",
    "Asia/Anadyr",
    "Asia/Aqtau",
    "Asia/Aqtobe",
    "Asia/Ashgabat",
    "Asia/Ashkhabad",
    "Asia/Atyrau",
    "Asia/Baghdad",
    "Asia/Bahrain",
    "Asia/Baku",
    "Asia/Bangkok",
    "Asia/Barnaul",
    "Asia/Beirut",
    "Asia/Bishkek",
    "Asia/Brunei",
    "Asia/Calcutta",
    "Asia/Chita",
    "Asia/Choibalsan",
    "Asia/Chongqing",
    "Asia/Chungking",
    "Asia/Colombo",
    "Asia/Dacca",
    "Asia/Damascus",
    "Asia/Dhaka",
    "Asia/Dili",
    "Asia/Dubai",
    "Asia/Dushanbe",
    "Asia/Famagusta",
    "Asia/Gaza",
    "Asia/Harbin",
    "Asia/Hebron",
    "Asia/Ho_Chi_Minh",
    "Asia/Hong_Kong",
    "Asia/Hovd",
    "Asia/Irkutsk",
    "Asia/Istanbul",
    "Asia/Jakarta",
    "Asia/Jayapura",
    "Asia/Jerusalem",
    "Asia/Kabul",
    "Asia/Kamchatka",
    "Asia/Karachi",
    "Asia/Kashgar",
    "Asia/Kathmandu",
    "Asia/Katmandu",
    "Asia/Khandyga",
    "Asia/Kolkata",
    "Asia/Krasnoyarsk",
    "Asia/Kuala_Lumpur",
    "Asia/Kuching",
    "Asia/Kuwait",
    "Asia/Macao",
    "Asia/Macau",
    "Asia/Magadan",
    "Asia/Makassar",
    "Asia/Manila",
    "Asia/Muscat",
    "Asia/Nicosia",
    "Asia/Novokuznetsk",
    "Asia/Novosibirsk",
    "Asia/Omsk",
    "Asia/Oral",
    "Asia/Phnom_Penh",
    "Asia/Pontianak",
    "Asia/Pyongyang",
    "Asia/Qatar",
    "Asia/Qyzylorda",
    "Asia/Rangoon",
    "Asia/Riyadh",
    "Asia/Saigon",
    "Asia/Sakhalin",
    "Asia/Samarkand",
    "Asia/Seoul",
    "Asia/Shanghai",
    "Asia/Singapore",
    "Asia/Srednekolymsk",
    "Asia/Taipei",
    "Asia/Tashkent",
    "Asia/Tbilisi",
    "Asia/Tehran",
    "Asia/Tel_Aviv",
    "Asia/Thimbu",
    "Asia/Thimphu",
    "Asia/Tokyo",
    "Asia/Tomsk",
    "Asia/Ujung_Pandang",
    "Asia/Ulaanbaatar",
    "Asia/Ulan_Bator",
    "Asia/Urumqi",
    "Asia/Ust-Nera",
    "Asia/Vientiane",
    "Asia/Vladivostok",
    "Asia/Yakutsk",
    "Asia/Yangon",
    "Asia/Yekaterinburg",
    "Asia/Yerevan",
    "Atlantic/Azores",
    "Atlantic/Bermuda",
    "Atlantic/Canary",
    "Atlantic/Cape_Verde",
    "Atlantic/Faeroe",
    "Atlantic/Faroe",
    "Atlantic/Jan_Mayen",
    "Atlantic/Madeira",
    "Atlantic/Reykjavik",
    "Atlantic/South_Georgia",
    "Atlantic/St_Helena",
    "Atlantic/Stanley",
    "Australia/ACT",
    "Australia/Adelaide",
    "Australia/Brisbane",
    "Australia/Broken_Hill",
    "Australia/Canberra",
    "Australia/Currie",
    "Australia/Darwin",
    "Australia/Eucla",
    "Australia/Hobart",
    "Australia/LHI",
    "Australia/Lindeman",
    "Australia/Lord_Howe",
    "Australia/Melbourne",
    "Australia/North",
    "Australia/NSW",
    "Australia/Perth",
    "Australia/Queensland",
    "Australia/South",
    "Australia/Sydney",
    "Australia/Tasmania",
    "Australia/Victoria",
    "Australia/West",
    "Australia/Yancowinna",
    "Brazil/Acre",
    "Brazil/DeNoronha",
    "Brazil/East",
    "Brazil/West",
    "Canada/Atlantic",
    "Canada/Central",
    "Canada/Eastern",
    "Canada/Mountain",
    "Canada/Newfoundland",
    "Canada/Pacific",
    "Canada/Saskatchewan",
    "Canada/Yukon",
    "Chile/Continental",
    "Chile/EasterIsland",
    "Cuba",
    "Egypt",
    "Europe/Amsterdam",
    "Europe/Andorra",
    "Europe/Astrakhan",
    "Europe/Athens",
    "Europe/Belfast",
    "Europe/Belgrade",
    "Europe/Berlin",
    "Europe/Bratislava",
    "Europe/Brussels",
    "Europe/Bucharest",
    "Europe/Budapest",
    "Europe/Busingen",
    "Europe/Chisinau",
    "Europe/Copenhagen",
    "Europe/Dublin",
    "Europe/Gibraltar",
    "Europe/Guernsey",
    "Europe/Helsinki",
    "Europe/Isle_of_Man",
    "Europe/Istanbul",
    "Europe/Jersey",
    "Europe/Kaliningrad",
    "Europe/Kiev",
    "Europe/Kirov",
    "Europe/Lisbon",
    "Europe/Ljubljana",
    "Europe/London",
    "Europe/Luxembourg",
    "Europe/Madrid",
    "Europe/Malta",
    "Europe/Mariehamn",
    "Europe/Minsk",
    "Europe/Monaco",
    "Europe/Moscow",
    "Europe/Oslo",
    "Europe/Paris",
    "Europe/Podgorica",
    "Europe/Prague",
    "Europe/Riga",
    "Europe/Rome",
    "Europe/Samara",
    "Europe/San_Marino",
    "Europe/Sarajevo",
    "Europe/Saratov",
    "Europe/Simferopol",
    "Europe/Skopje",
    "Europe/Sofia",
    "Europe/Stockholm",
    "Europe/Tallinn",
    "Europe/Tirane",
    "Europe/Tiraspol",
    "Europe/Ulyanovsk",
    "Europe/Uzhgorod",
    "Europe/Vaduz",
    "Europe/Vatican",
    "Europe/Vienna",
    "Europe/Vilnius",
    "Europe/Volgograd",
    "Europe/Warsaw",
    "Europe/Zagreb",
    "Europe/Zaporozhye",
    "Europe/Zurich",
    "Iceland",
    "Indian/Antananarivo",
    "Indian/Chagos",
    "Indian/Christmas",
    "Indian/Cocos",
    "Indian/Comoro",
    "Indian/Kerguelen",
    "Indian/Mahe",
    "Indian/Maldives",
    "Indian/Mauritius",
    "Indian/Mayotte",
    "Indian/Reunion",
    "Iran",
    "Israel",
    "Jamaica",
    "Japan",
    "Kwajalein",
    "Libya",
    "Mexico/BajaNorte",
    "Mexico/BajaSur",
    "Mexico/General",
    "Pacific/Apia",
    "Pacific/Auckland",
    "Pacific/Bougainville",
    "Pacific/Chatham",
    "Pacific/Chuuk",
    "Pacific/Easter",
    "Pacific/Efate",
    "Pacific/Enderbury",
    "Pacific/Fakaofo",
    "Pacific/Fiji",
    "Pacific/Funafuti",
    "Pacific/Galapagos",
    "Pacific/Gambier",
    "Pacific/Guadalcanal",
    "Pacific/Guam",
    "Pacific/Honolulu",
    "Pacific/Johnston",
    "Pacific/Kiritimati",
    "Pacific/Kosrae",
    "Pacific/Kwajalein",
    "Pacific/Majuro",
    "Pacific/Marquesas",
    "Pacific/Midway",
    "Pacific/Nauru",
    "Pacific/Niue",
    "Pacific/Norfolk",
    "Pacific/Noumea",
    "Pacific/Pago_Pago",
    "Pacific/Palau",
    "Pacific/Pitcairn",
    "Pacific/Pohnpei",
    "Pacific/Ponape",
    "Pacific/Port_Moresby",
    "Pacific/Rarotonga",
    "Pacific/Saipan",
    "Pacific/Samoa",
    "Pacific/Tahiti",
    "Pacific/Tarawa",
    "Pacific/Tongatapu",
    "Pacific/Truk",
    "Pacific/Wake",
    "Pacific/Wallis",
    "Pacific/Yap",
    "Poland",
    "Portugal",
    "Singapore",
    "Turkey",
    "US/Alaska",
    "US/Aleutian",
    "US/Arizona",
    "US/Central",
    "US/East-Indiana",
    "US/Eastern",
    "US/Hawaii",
    "US/Indiana-Starke",
    "US/Michigan",
    "US/Mountain",
    "US/Pacific",
    "US/Samoa",
];

/**
 *  Global definitions for package management.
 */

export const PackageTypes = {
    AVAILABLE: 0,
    USER: 1,
    SYSTEM: 2,
    LAUNCHABLE: 3,
    ALL: 4,
};

/**
 *  Frequently used command parameters. Their schemas are reused.
 */
const parameterSchemas = {
    mode: {
        title: i18next.t("modals:newPolicyCommand.parameterSchemas.mode.title"),
        type: "string",
        pattern: "^[0-7]{3}$",
        options: {
            inputAttributes: {
                placeholder: i18next.t("modals:newPolicyCommand.parameterSchemas.mode.placeholder"),
            },
        },
    },
    version: {
        title: i18next.t("modals:newPolicyCommand.parameterSchemas.version.title"),
        type: "string",
        pattern: "^[0-9]+$",
        options: {
            inputAttributes: {
                placeholder: i18next.t("modals:newPolicyCommand.parameterSchemas.version.placeholder"),
            },
        },
    },
    type: {
        title: i18next.t("modals:newPolicyCommand.parameterSchemas.type.title"),
        type: "string",
        enum: ["int", "long", "float", "bool", "string", "set"],
        options: {
            enum_titles: [
                i18next.t("modals:newPolicyCommand.parameterSchemas.type.options.int"),
                i18next.t("modals:newPolicyCommand.parameterSchemas.type.options.long"),
                i18next.t("modals:newPolicyCommand.parameterSchemas.type.options.float"),
                i18next.t("modals:newPolicyCommand.parameterSchemas.type.options.bool"),
                i18next.t("modals:newPolicyCommand.parameterSchemas.type.options.string"),
                i18next.t("modals:newPolicyCommand.parameterSchemas.type.options.set"),
            ],
        },
        default: "int",
    },
    intent: {
        title: i18next.t("modals:newPolicyCommand.parameterSchemas.intent.title"),
        type: "object",
    },
};

export type CommandPayload<T extends Record<string, unknown | unknown[]> = Record<string, unknown>> = {
    command: string;
    caption: string;
} & T;

export type JsonEditorCommand = {
    name: string;
    title?: string;
    description?: string;
    type?: string;
    options?: {
        compact?: string;
        disable_properties?: string;
        hidden?: boolean;
    };
    template?: CommandPayload;
    schema: {
        title: string;
        description: string;
        type: string;
        options: Record<string, unknown>;
        properties?: {
            [key: string]: Record<string, unknown>;
        };
        required?: string[];
    };
};

/**
 * Schemas and predefined command parameter values for simple commands.
 */
export const simpleCommands: JsonEditorCommand[] = [
    {
        name: "changeAutostartApps",
        template: {
            command: "processSubcommands",
            caption: i18next.t("modals:newPolicyCommand.command.changeAutostartApps.caption"),
            success: "any",
        },
        schema: {
            title: i18next.t("modals:newPolicyCommand.command.changeAutostartApps.caption"),
            description: i18next.t("modals:newPolicyCommand.command.changeAutostartApps.description"),
            type: "object",
            options: {
                compact: "true",
            },
            properties: {
                list: {
                    title: i18next.t("modals:newPolicyCommand.command.changeAutostartApps.list.title"),
                    type: "string",
                    minLength: 8,
                    options: {
                        inputAttributes: {
                            placeholder: i18next.t("modals:newPolicyCommand.command.changeAutostartApps.list.placeholder"),
                        },
                    },
                },
                subcommands: {
                    title: i18next.t("modals:newPolicyCommand.command.changeAutostartApps.subcommands.title"),
                    type: "array",
                    options: {
                        hidden: true,
                    },
                    items: {
                        type: "object",
                        properties: {
                            command: {
                                type: "string",
                                default: "changePreference",
                            },
                            key: {
                                type: "string",
                                default: "autostart_apps",
                            },
                            type: {
                                type: "string",
                                default: "set",
                            },
                            value: {
                                type: "string",
                                template: "{{reference}}",
                                watch: {
                                    reference: "list",
                                },
                            },
                        },
                    },
                    default: [
                        {
                            package: "com.emteria.settings",
                            category: "com.emteria.settings_preferences",
                        },
                        {
                            package: "com.emteria.kiosk",
                            category: "com.emteria.kiosk_preferences",
                        },
                    ],
                },
            },
            required: ["list"],
        },
    },
    {
        name: "changeAutostartMode",
        template: {
            command: "processSubcommands",
            caption: i18next.t("modals:newPolicyCommand.command.changeAutostartMode.caption"),
            success: "any",
        },
        schema: {
            title: i18next.t("modals:newPolicyCommand.command.changeAutostartMode.caption"),
            description: i18next.t("modals:newPolicyCommand.command.changeAutostartMode.description"),
            type: "object",
            options: {
                compact: "true",
            },
            properties: {
                enabled: {
                    title: i18next.t("modals:newPolicyCommand.command.changeAutostartMode.value.title"),
                    type: "string",
                    enum: ["true", "false"],
                    options: {
                        enum_titles: [
                            i18next.t("modals:newPolicyCommand.command.changeAutostartMode.value.options.enable"),
                            i18next.t("modals:newPolicyCommand.command.changeAutostartMode.value.options.disable"),
                        ],
                    },
                    default: "true",
                },
                subcommands: {
                    title: i18next.t("modals:newPolicyCommand.command.changeAutostartMode.subcommands.title"),
                    type: "array",
                    options: {
                        hidden: true,
                    },
                    items: {
                        type: "object",
                        properties: {
                            command: {
                                type: "string",
                                default: "changePreference",
                            },
                            key: {
                                type: "string",
                                default: "autostart_enabled",
                            },
                            type: {
                                type: "string",
                                default: "bool",
                            },
                            value: {
                                type: "string",
                                template: "{{reference}}",
                                watch: {
                                    "reference": "enabled",
                                },
                            },
                        },
                    },
                    default: [
                        {
                            package: "com.emteria.settings",
                            category: "com.emteria.settings_preferences",
                        },
                        {
                            package: "com.emteria.kiosk",
                            category: "com.emteria.kiosk_preferences",
                        },
                    ],
                },
            },
            required: ["enabled"],
        },
    },
    {
        name: "changeKioskApps",
        template: {
            command: "changePreference",
            caption: i18next.t("modals:newPolicyCommand.command.changeKioskApps.caption"),
            package: "com.emteria.kiosk",
            category: "com.emteria.kiosk_preferences",
            key: "prefs_allowed_apps",
            type: "set",
        },
        schema: {
            title: i18next.t("modals:newPolicyCommand.command.changeKioskApps.caption"),
            description: i18next.t("modals:newPolicyCommand.command.changeKioskApps.description"),
            type: "object",
            options: {
                compact: "true",
            },
            properties: {
                value: {
                    title: i18next.t("modals:newPolicyCommand.command.changeKioskApps.list.title"),
                    type: "string",
                    minLength: 8,
                    options: {
                        inputAttributes: {
                            placeholder: i18next.t("modals:newPolicyCommand.command.changeKioskApps.list.placeholder"),
                        },
                    },
                },
            },
            required: ["value"],
        },
    },
    {
        name: "changeKioskMode",
        template: {
            command: "sendBroadcast",
            caption: i18next.t("modals:newPolicyCommand.command.changeKioskMode.caption"),
        },
        schema: {
            title: i18next.t("modals:newPolicyCommand.command.changeKioskMode.caption"),
            description: i18next.t("modals:newPolicyCommand.command.changeKioskMode.description"),
            type: "object",
            options: {
                compact: "true",
                disable_properties: true,
            },
            properties: {
                intent: {
                    title: i18next.t("modals:newPolicyCommand.command.changeKioskMode.intent.title"),
                    type: "object",
                    properties: {
                        component: {
                            title: i18next.t("modals:newPolicyCommand.command.changeKioskMode.intent.component.title"),
                            type: "string",
                            default: "com.emteria.kiosk/.receivers.EnabledReceiver",
                            options: {
                                hidden: true,
                            },
                        },
                        action: {
                            title: i18next.t("modals:newPolicyCommand.command.changeKioskMode.intent.action.title"),
                            type: "string",
                            enum: ["emteria.intent.action.SET_KIOSK_ENABLED", "emteria.intent.action.SET_KIOSK_DISABLED"],
                            options: {
                                enum_titles: [
                                    i18next.t("modals:newPolicyCommand.command.changeKioskMode.intent.action.options.enable"),
                                    i18next.t("modals:newPolicyCommand.command.changeKioskMode.intent.action.options.disable"),
                                ],
                            },
                        },
                    },
                    required: ["action"],
                },
            },
        },
    },
    {
        name: "changeKioskPassword",
        template: {
            command: "changePreference",
            caption: i18next.t("modals:newPolicyCommand.command.changeKioskPassword.caption"),
            package: "com.emteria.kiosk",
            category: "com.emteria.kiosk_preferences",
            key: "prefs_password_key",
            type: "string",
        },
        schema: {
            title: i18next.t("modals:newPolicyCommand.command.changeKioskPassword.caption"),
            description: i18next.t("modals:newPolicyCommand.command.changeKioskPassword.description"),
            type: "object",
            options: {
                compact: "true",
            },
            properties: {
                value: {
                    title: i18next.t("modals:newPolicyCommand.command.changeKioskPassword.value.title"),
                    type: "string",
                    options: {
                        inputAttributes: {
                            placeholder: i18next.t("modals:newPolicyCommand.command.changeKioskPassword.value.placeholder"),
                        },
                    },
                },
            },
            required: ["value"],
        },
    },
    {
        name: "changeKioskSetting",
        template: {
            command: "changePreference",
            caption: i18next.t("modals:newPolicyCommand.command.changeKioskSetting.caption"),
            package: "com.emteria.kiosk",
            category: "com.emteria.kiosk_preferences",
            key: "prefs_kiosk_enabled_key",
            type: "bool",
        },
        schema: {
            title: i18next.t("modals:newPolicyCommand.command.changeKioskSetting.caption"),
            description: i18next.t("modals:newPolicyCommand.command.changeKioskSetting.description"),
            type: "object",
            options: {
                compact: "true",
            },
            properties: {
                value: {
                    title: i18next.t("modals:newPolicyCommand.command.changeKioskSetting.value.title"),
                    type: "string",
                    enum: ["true", "false"],
                    options: {
                        enum_titles: [
                            i18next.t("modals:newPolicyCommand.command.changeKioskSetting.value.options.enable"),
                            i18next.t("modals:newPolicyCommand.command.changeKioskSetting.value.options.disable"),
                        ],
                    },
                    default: "true",
                },
            },
            required: ["value"],
        },
    },
    {
        name: "changePasswordVisibility",
        template: {
            command: "changeSetting",
            caption: i18next.t("modals:newPolicyCommand.command.changeSetting.caption"),
            section: "System",
            type: "int",
            key: "show_password",
        },
        schema: {
            title: i18next.t("modals:newPolicyCommand.command.changeSetting.caption"),
            description: i18next.t("modals:newPolicyCommand.command.changeSetting.description"),
            type: "object",
            options: {
                compact: "true",
            },
            properties: {
                value: {
                    title: i18next.t("modals:newPolicyCommand.command.changeSetting.value.title"),
                    type: "string",
                    enum: ["1", "0"],
                    options: {
                        enum_titles: [
                            i18next.t("modals:newPolicyCommand.command.changeSetting.value.options.show"),
                            i18next.t("modals:newPolicyCommand.command.changeSetting.value.options.hide"),
                        ],
                    },
                    default: "1",
                },
            },
            required: ["value"],
        },
    },
    {
        name: "changeScreenRotation",
        template: {
            command: "changeSetting",
            caption: i18next.t("modals:newPolicyCommand.command.changeScreenRotation.caption"),
            section: "System",
            type: "int",
            key: "user_rotation",
        },
        schema: {
            title: i18next.t("modals:newPolicyCommand.command.changeScreenRotation.caption"),
            description: i18next.t("modals:newPolicyCommand.command.changeScreenRotation.description"),
            type: "object",
            options: {
                compact: "true",
            },
            properties: {
                value: {
                    title: i18next.t("modals:newPolicyCommand.command.changeScreenRotation.value.title"),
                    type: "string",
                    enum: ["0", "1", "2", "3"],
                    options: {
                        enum_titles: ["0°", "90°", "180°", "270°"],
                    },
                },
            },
            required: ["value"],
        },
    },
    {
        name: "changeTimezone",
        template: {
            command: "changeProperty",
            caption: i18next.t("modals:newPolicyCommand.command.changeTimezone.caption"),
            property: "persist.sys.timezone",
        },
        schema: {
            title: i18next.t("modals:newPolicyCommand.command.changeTimezone.caption"),
            description: i18next.t("modals:newPolicyCommand.command.changeTimezone.description"),
            type: "object",
            options: {
                compact: "true",
            },
            properties: {
                value: {
                    title: i18next.t("modals:newPolicyCommand.command.changeTimezone.value.title"),
                    type: "string",
                    enum: AllTimezones,
                },
            },
            required: ["value"],
        },
    },
    {
        name: "rebootDevice",
        template: {
            command: "rebootDevice",
            caption: i18next.t("modals:newPolicyCommand.command.rebootDevice.caption"),
        },
        schema: {
            title: i18next.t("modals:newPolicyCommand.command.rebootDevice.caption"),
            description: i18next.t("modals:newPolicyCommand.command.rebootDevice.description"),
            type: "object",
            options: {
                compact: true,
            },
            properties: {
                reason: {
                    title: i18next.t("common:label.reason"),
                    type: "string",
                    options: {
                        inputAttributes: {
                            placeholder: i18next.t("modals:newPolicyCommand.command.rebootDevice.value.placeholder"),
                        },
                    },
                },
            },
            required: ["reason"],
        },
    },
    {
        name: "startOsUpdate",
        template: {
            command: "startService",
            caption: i18next.t("modals:newPolicyCommand.command.startOsUpdate.caption"),
            intent: {
                component: "com.emteria.update/.UpdateService",
            },
        },
        schema: {
            title: i18next.t("modals:newPolicyCommand.command.startOsUpdate.caption"),
            description: i18next.t("modals:newPolicyCommand.command.startOsUpdate.description"),
            type: "object",
            options: {
                compact: "true",
            },
            properties: {
                action: {
                    title: i18next.t("modals:newPolicyCommand.command.startOsUpdate.value.title"),
                    type: "string",
                    enum: ["installLatest", "downloadSpecific", "installSpecific"],
                    options: {
                        enum_titles: [
                            i18next.t("modals:newPolicyCommand.command.startOsUpdate.value.options.installLatest"),
                            i18next.t("modals:newPolicyCommand.command.startOsUpdate.value.options.download"),
                            i18next.t("modals:newPolicyCommand.command.startOsUpdate.value.options.install"),
                        ],
                    },
                    default: "installLatest",
                },
                version: {
                    title: i18next.t("modals:newPolicyCommand.command.startOsUpdate.version.title"),
                    type: "string",
                    pattern: "^(\\d+(\\.\\d+){0,2})?$",
                    options: {
                        dependencies: {
                            action: ["installSpecific", "downloadSpecific"],
                        },
                        inputAttributes: {
                            placeholder: i18next.t("modals:newPolicyCommand.command.startOsUpdate.version.placeholder"),
                        },
                        patternmessage: i18next.t("modals:newPolicyCommand.command.startOsUpdate.version.patternError"),
                    },
                },
            },
            required: ["action"],
        },
    },
    {
        name: "submitBugreport",
        template: {
            command: "processSubcommands",
            caption: i18next.t("modals:newPolicyCommand.command.submitBugreport.caption"),
            success: "any",
            subcommands: [
                {
                    command: "changeProperty",
                    property: "ctl.start",
                    value: "sendreport",
                },
                {
                    command: "sendBroadcast",
                    intent: {
                        component: "com.emteria.bugreport/.RequestReceiver",
                        action: "emteria.intent.action.BUGREPORT_REQUESTED",
                    },
                },
            ],
        },
        schema: {
            title: i18next.t("modals:newPolicyCommand.command.submitBugreport.caption"),
            description: i18next.t("modals:newPolicyCommand.command.submitBugreport.description"),
            type: "object",
            options: {
                compact: "true",
            },
        },
    },
];

/**
 *  Schema templates for complex commands.
 */
export const complexCommands: JsonEditorCommand[] = [
    {
        name: "changePreference",
        schema: {
            title: i18next.t("modals:newPolicyCommand.complexCommand.changePreference.caption"),
            description: i18next.t("modals:newPolicyCommand.complexCommand.changePreference.description"),
            type: "object",
            options: {
                compact: "true",
                disable_properties: "true",
            },
            properties: {
                package: {
                    packageType: PackageTypes.SYSTEM,
                    title: i18next.t("modals:newPolicyCommand.complexCommand.changePreference.package.title"),
                    type: "string",
                    enum: [],
                    default: "",
                },
                category: {
                    title: i18next.t("modals:newPolicyCommand.complexCommand.changePreference.category.title"),
                    type: "string",
                    minLength: 4,
                    options: {
                        inputAttributes: {
                            placeholder: i18next.t(
                                "modals:newPolicyCommand.complexCommand.changePreference.category.placeholder",
                            ),
                        },
                    },
                },
                type: parameterSchemas.type,
                key: {
                    title: i18next.t("modals:newPolicyCommand.complexCommand.changePreference.key.title"),
                    type: "string",
                    minLength: 4,
                    options: {
                        inputAttributes: {
                            placeholder: i18next.t("modals:newPolicyCommand.complexCommand.changePreference.key.placeholder"),
                        },
                    },
                },
                value: {
                    title: i18next.t("modals:newPolicyCommand.complexCommand.changePreference.value.title"),
                    type: "string",
                    options: {
                        inputAttributes: {
                            placeholder: i18next.t("modals:newPolicyCommand.complexCommand.changePreference.value.placeholder"),
                        },
                    },
                },
            },
            required: ["package", "category", "type", "key", "value"],
        },
    },
    {
        name: "changeProperty",
        schema: {
            title: i18next.t("modals:newPolicyCommand.complexCommand.changeProperty.caption"),
            description: i18next.t("modals:newPolicyCommand.complexCommand.changeProperty.description"),
            type: "object",
            options: {
                compact: "true",
                disable_properties: "true",
            },
            properties: {
                property: {
                    type: "string",
                    title: i18next.t("modals:newPolicyCommand.complexCommand.changeProperty.property.title"),
                    minLength: 4,
                    options: {
                        inputAttributes: {
                            placeholder: i18next.t("modals:newPolicyCommand.complexCommand.changeProperty.property.placeholder"),
                        },
                    },
                },
                value: {
                    type: "string",
                    title: i18next.t("modals:newPolicyCommand.complexCommand.changeProperty.value.title"),
                    options: {
                        inputAttributes: {
                            placeholder: i18next.t("modals:newPolicyCommand.complexCommand.changeProperty.value.placeholder"),
                        },
                    },
                },
            },
            required: ["property", "value"],
        },
    },
    {
        name: "changeSetting",
        schema: {
            title: i18next.t("modals:newPolicyCommand.complexCommand.changeSetting.caption"),
            description: i18next.t("modals:newPolicyCommand.complexCommand.changeSetting.description"),
            type: "object",
            options: {
                compact: "true",
                disable_properties: "true",
            },
            properties: {
                section: {
                    title: i18next.t("modals:newPolicyCommand.complexCommand.changeSetting.section.title"),
                    type: "string",
                    enum: ["system", "global", "secure"],
                    options: {
                        enum_titles: [
                            i18next.t("modals:newPolicyCommand.complexCommand.changeSetting.section.options.system"),
                            i18next.t("modals:newPolicyCommand.complexCommand.changeSetting.section.options.global"),
                            i18next.t("modals:newPolicyCommand.complexCommand.changeSetting.section.options.secure"),
                        ],
                    },
                    default: "system",
                },
                type: parameterSchemas.type,
                key: {
                    type: "string",
                    title: i18next.t("modals:newPolicyCommand.complexCommand.changeSetting.key.title"),
                    minLength: 4,
                    options: {
                        inputAttributes: {
                            placeholder: i18next.t("modals:newPolicyCommand.complexCommand.changeSetting.key.placeholder"),
                        },
                    },
                },
                value: {
                    title: i18next.t("modals:newPolicyCommand.complexCommand.changeSetting.value.title"),
                    type: "string",
                    options: {
                        inputAttributes: {
                            placeholder: i18next.t("modals:newPolicyCommand.complexCommand.changeSetting.value.placeholder"),
                        },
                    },
                },
            },
            required: ["section", "type", "key", "value"],
        },
    },
    {
        name: "copyFile",
        schema: {
            title: i18next.t("modals:newPolicyCommand.complexCommand.copyFile.caption"),
            description: i18next.t("modals:newPolicyCommand.complexCommand.copyFile.description"),
            type: "object",
            options: {
                compact: "true",
                disable_properties: "true",
            },
            properties: {
                source: {
                    title: i18next.t("modals:newPolicyCommand.complexCommand.copyFile.source.title"),
                    type: "string",
                    minLength: 2,
                    options: {
                        inputAttributes: {
                            placeholder: i18next.t("modals:newPolicyCommand.complexCommand.copyFile.source.placeholder"),
                        },
                    },
                },
                destination: {
                    title: i18next.t("modals:newPolicyCommand.complexCommand.copyFile.destination.title"),
                    type: "string",
                    minLength: 2,
                    options: {
                        inputAttributes: {
                            placeholder: i18next.t("modals:newPolicyCommand.complexCommand.copyFile.destination.placeholder"),
                        },
                    },
                },
                mode: parameterSchemas.mode,
            },
            required: ["source", "destination", "mode"],
        },
    },
    {
        name: "deletePath",
        schema: {
            title: i18next.t("modals:newPolicyCommand.complexCommand.deletePath.caption"),
            description: i18next.t("modals:newPolicyCommand.complexCommand.deletePath.description"),
            type: "object",
            options: {
                compact: "true",
                disable_properties: "true",
            },
            properties: {
                path: {
                    title: i18next.t("modals:newPolicyCommand.complexCommand.deletePath.path.title"),
                    type: "string",
                    minLength: 3,
                    options: {
                        inputAttributes: {
                            placeholder: i18next.t("modals:newPolicyCommand.complexCommand.deletePath.path.placeholder"),
                        },
                    },
                },
            },
            required: ["path"],
        },
    },
    {
        name: "downloadFile",
        schema: {
            title: i18next.t("modals:newPolicyCommand.complexCommand.downloadFile.caption"),
            description: i18next.t("modals:newPolicyCommand.complexCommand.downloadFile.description"),
            type: "object",
            options: {
                compact: "true",
                disable_properties: "true",
            },
            properties: {
                url: {
                    title: i18next.t("modals:newPolicyCommand.complexCommand.downloadFile.url.title"),
                    type: "string",
                    minLength: 8,
                    options: {
                        inputAttributes: {
                            placeholder: i18next.t("modals:newPolicyCommand.complexCommand.downloadFile.url.placeholder"),
                        },
                    },
                },
                path: {
                    title: i18next.t("modals:newPolicyCommand.complexCommand.downloadFile.path.title"),
                    type: "string",
                    minLength: 2,
                    options: {
                        inputAttributes: {
                            placeholder: i18next.t("modals:newPolicyCommand.complexCommand.downloadFile.path.placeholder"),
                        },
                    },
                },
                mode: parameterSchemas.mode,
            },
            required: ["url", "path", "mode"],
        },
    },
    {
        name: "enablePackage",
        schema: {
            title: i18next.t("modals:newPolicyCommand.complexCommand.enablePackage.caption"),
            description: i18next.t("modals:newPolicyCommand.complexCommand.enablePackage.description"),
            type: "object",
            options: {
                compact: "true",
                disable_properties: "true",
            },
            properties: {
                package: {
                    packageType: PackageTypes.AVAILABLE,
                    title: i18next.t("modals:newPolicyCommand.complexCommand.enablePackage.package.title"),
                    type: "string",
                    enum: [],
                    default: "",
                },
                state: {
                    title: i18next.t("modals:newPolicyCommand.complexCommand.enablePackage.state.title"),
                    type: "string",
                    enum: ["1", "0"],
                    options: {
                        enum_titles: [
                            i18next.t("modals:newPolicyCommand.complexCommand.enablePackage.state.options.enable"),
                            i18next.t("modals:newPolicyCommand.complexCommand.enablePackage.state.options.disable"),
                        ],
                    },
                },
            },
            required: ["package", "state"],
        },
    },
    {
        name: "enableRestriction",
        schema: {
            title: i18next.t("modals:newPolicyCommand.complexCommand.enableRestriction.caption"),
            description: i18next.t("modals:newPolicyCommand.complexCommand.enableRestriction.description"),
            type: "object",
            options: {
                compact: "true",
                disable_properties: "true",
            },
            properties: {
                key: {
                    type: "string",
                    title: i18next.t("modals:newPolicyCommand.complexCommand.enableRestriction.restriction.title"),
                    minLength: 4,
                    options: {
                        inputAttributes: {
                            placeholder: i18next.t(
                                "modals:newPolicyCommand.complexCommand.enableRestriction.restriction.placeholder",
                            ),
                        },
                    },
                },
                state: {
                    type: "string",
                    title: i18next.t("modals:newPolicyCommand.complexCommand.enableRestriction.desiredAction.title"),
                    enum: ["1", "0"],
                    options: {
                        enum_titles: [
                            i18next.t("modals:newPolicyCommand.complexCommand.enableRestriction.desiredAction.options.enable"),
                            i18next.t("modals:newPolicyCommand.complexCommand.enableRestriction.desiredAction.options.disable"),
                        ],
                    },
                },
            },
            required: ["key", "state"],
        },
    },
    {
        name: "changePermission",
        schema: {
            title: i18next.t("modals:newPolicyCommand.complexCommand.changePermission.caption"),
            description: i18next.t("modals:newPolicyCommand.complexCommand.changePermission.description"),
            type: "object",
            options: {
                compact: "true",
                disable_properties: "true",
            },
            properties: {
                package: {
                    packageType: PackageTypes.USER,
                    title: i18next.t("modals:newPolicyCommand.complexCommand.changePermission.package.title"),
                    type: "string",
                    enum: [],
                    default: "",
                },
                permission: {
                    title: i18next.t("modals:newPolicyCommand.complexCommand.changePermission.permission.title"),
                    type: "string",
                    minLength: 4,
                    options: {
                        inputAttributes: {
                            placeholder: i18next.t(
                                "modals:newPolicyCommand.complexCommand.changePermission.permission.placeholder",
                            ),
                        },
                    },
                },
                action: {
                    title: i18next.t("modals:newPolicyCommand.complexCommand.changePermission.desiredAction.title"),
                    type: "string",
                    enum: ["grant", "revoke"],
                    options: {
                        enum_titles: [
                            i18next.t("modals:newPolicyCommand.complexCommand.changePermission.desiredAction.options.grant"),
                            i18next.t("modals:newPolicyCommand.complexCommand.changePermission.desiredAction.options.revoke"),
                        ],
                    },
                },
            },
            required: ["package", "permission", "action"],
        },
    },
    {
        name: "installCertificate",
        schema: {
            title: i18next.t("modals:newPolicyCommand.complexCommand.installCertificate.caption"),
            description: i18next.t("modals:newPolicyCommand.complexCommand.installCertificate.description"),
            type: "object",
            options: {
                compact: "true",
                disable_properties: "true",
            },
            properties: {
                path: {
                    type: "string",
                    title: i18next.t("modals:newPolicyCommand.complexCommand.installCertificate.path.title"),
                    minLength: 2,
                    options: {
                        inputAttributes: {
                            placeholder: i18next.t("modals:newPolicyCommand.complexCommand.installCertificate.path.placeholder"),
                        },
                    },
                },
            },
            required: ["path"],
        },
    },
    {
        name: "installPackage",
        schema: {
            title: i18next.t("modals:newPolicyCommand.complexCommand.installPackage.caption"),
            description: i18next.t("modals:newPolicyCommand.complexCommand.installPackage.description"),
            type: "object",
            options: {
                compact: "true",
                disable_properties: "true",
            },
            properties: {
                url: {
                    type: "string",
                    title: i18next.t("modals:newPolicyCommand.complexCommand.installPackage.url.title"),
                    minLength: 8,
                    options: {
                        inputAttributes: {
                            placeholder: i18next.t("modals:newPolicyCommand.complexCommand.installPackage.url.placeholder"),
                        },
                    },
                },
                package: {
                    title: i18next.t("modals:newPolicyCommand.complexCommand.installPackage.package.title"),
                    type: "string",
                    minLength: 8,
                    options: {
                        inputAttributes: {
                            placeholder: i18next.t("modals:newPolicyCommand.complexCommand.installPackage.package.placeholder"),
                        },
                    },
                },
                version: {
                    title: i18next.t("modals:newPolicyCommand.complexCommand.installPackage.version.title"),
                    type: "string",
                    pattern: "^[0-9]+$",
                    options: {
                        inputAttributes: {
                            placeholder: i18next.t("modals:newPolicyCommand.complexCommand.installPackage.version.placeholder"),
                        },
                    },
                },
                source: {
                    title: i18next.t("common:label.source"),
                    type: "string",
                    enum: ["url", "storage"],
                    options: {
                        enum_titles: [
                            i18next.t("common:label.url"),
                            i18next.t("modals:newPolicyCommand.complexCommand.installPackage.source.options.storage"),
                        ],
                        hidden: true,
                    },
                    default: "url",
                },
            },
            required: ["url", "package", "version"],
        },
    },
    {
        name: "processSubcommands",
        schema: {
            title: i18next.t("modals:newPolicyCommand.complexCommand.processSubcommands.caption"),
            description: i18next.t("modals:newPolicyCommand.complexCommand.processSubcommands.description"),
            type: "object",
            options: {
                compact: "true",
                disable_properties: "false",
            },
            properties: {
                success: {
                    title: i18next.t("modals:newPolicyCommand.complexCommand.processSubcommands.success.title"),
                    type: "string",
                    enum: ["all", "any"],
                    options: {
                        enum_titles: [
                            i18next.t("modals:newPolicyCommand.complexCommand.processSubcommands.success.options.all"),
                            i18next.t("modals:newPolicyCommand.complexCommand.processSubcommands.success.options.any"),
                        ],
                    },
                },
                subcommands: {
                    title: i18next.t("modals:newPolicyCommand.complexCommand.processSubcommands.subcommands.title"),
                    type: "array",
                },
            },
        },
    },
    {
        name: "rebootDevice",
        schema: {
            title: i18next.t("modals:newPolicyCommand.complexCommand.rebootDevice.caption"),
            description: i18next.t("modals:newPolicyCommand.complexCommand.rebootDevice.description"),
            type: "object",
            options: {
                compact: "true",
                disable_properties: "true",
            },
            properties: {
                reason: {
                    title: i18next.t("common:label.reason"),
                    type: "string",
                    options: {
                        inputAttributes: {
                            placeholder: i18next.t("modals:newPolicyCommand.complexCommand.rebootDevice.reason.placeholder"),
                        },
                    },
                },
            },
            required: ["reason"],
        },
    },
    {
        name: "sendBroadcast",
        schema: {
            title: i18next.t("modals:newPolicyCommand.complexCommand.sendBroadcast.caption"),
            description: i18next.t("modals:newPolicyCommand.complexCommand.sendBroadcast.description"),
            type: "object",
            options: {
                compact: "true",
                disable_properties: "true",
            },
            properties: {
                intent: parameterSchemas.intent,
            },
            required: ["intent"],
        },
    },
    {
        name: "setupEthernetMode",
        schema: {
            title: i18next.t("modals:newPolicyCommand.complexCommand.setupEthernetMode.caption"),
            description: i18next.t("modals:newPolicyCommand.complexCommand.setupEthernetMode.description"),
            type: "object",
            options: {
                compact: "true",
                disable_properties: "true",
            },
            properties: {
                mode: {
                    title: i18next.t("modals:newPolicyCommand.complexCommand.setupEthernetMode.mode.title"),
                    type: "string",
                    enum: ["dhcp", "static"],
                    options: {
                        enum_titles: ["DHCP", "Static"],
                    },
                },
                ip: {
                    title: i18next.t("modals:newPolicyCommand.complexCommand.setupEthernetMode.ipAddress.title"),
                    type: "string",
                    pattern: "[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}",
                    options: {
                        dependencies: {
                            mode: "static",
                        },
                        inputAttributes: {
                            placeholder: i18next.t(
                                "modals:newPolicyCommand.complexCommand.setupEthernetMode.ipAddress.placeholder",
                            ),
                        },
                    },
                },
                gateway: {
                    title: i18next.t("modals:newPolicyCommand.complexCommand.setupEthernetMode.gateway.title"),
                    type: "string",
                    pattern: "[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}",
                    options: {
                        dependencies: {
                            mode: "static",
                        },
                        inputAttributes: {
                            placeholder: i18next.t(
                                "modals:newPolicyCommand.complexCommand.setupEthernetMode.gateway.placeholder",
                            ),
                        },
                    },
                },
                netmask: {
                    title: i18next.t("modals:newPolicyCommand.complexCommand.setupEthernetMode.netmask.title"),
                    type: "string",
                    pattern: "[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}",
                    options: {
                        dependencies: {
                            mode: "static",
                        },
                        inputAttributes: {
                            placeholder: i18next.t(
                                "modals:newPolicyCommand.complexCommand.setupEthernetMode.netmask.placeholder",
                            ),
                        },
                    },
                },
                dns: {
                    title: i18next.t("modals:newPolicyCommand.complexCommand.setupEthernetMode.dns.title"),
                    type: "string",
                    pattern: "[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}",
                    options: {
                        dependencies: {
                            mode: "static",
                        },
                        inputAttributes: {
                            placeholder: i18next.t("modals:newPolicyCommand.complexCommand.setupEthernetMode.dns.placeholder"),
                        },
                    },
                },
            },
            required: ["mode", "ip", "gateway", "netmask", "dns"],
        },
    },
    {
        name: "setupEthernetProxy",
        schema: {
            title: i18next.t("modals:newPolicyCommand.complexCommand.setupEthernetProxy.caption"),
            description: i18next.t("modals:newPolicyCommand.complexCommand.setupEthernetProxy.description"),
            type: "object",
            options: {
                compact: "true",
                disable_properties: "true",
            },
            properties: {
                mode: {
                    type: "string",
                    title: i18next.t("modals:newPolicyCommand.complexCommand.setupEthernetProxy.mode.title"),
                    enum: ["none", "static", "pac"],
                    options: {
                        enum_titles: [
                            i18next.t("modals:newPolicyCommand.complexCommand.setupEthernetProxy.mode.options.none"),
                            i18next.t("modals:newPolicyCommand.complexCommand.setupEthernetProxy.mode.options.static"),
                            i18next.t("modals:newPolicyCommand.complexCommand.setupEthernetProxy.mode.options.pac"),
                        ],
                    },
                },
                host: {
                    title: i18next.t("modals:newPolicyCommand.complexCommand.setupEthernetProxy.host.title"),
                    type: "string",
                    options: {
                        dependencies: {
                            mode: "static",
                        },
                    },
                },
                port: {
                    title: i18next.t("modals:newPolicyCommand.complexCommand.setupEthernetProxy.port.title"),
                    type: "string",
                    options: {
                        dependencies: {
                            mode: "static",
                        },
                    },
                },
                pac: {
                    title: i18next.t("modals:newPolicyCommand.complexCommand.setupEthernetProxy.pac.title"),
                    type: "string",
                    options: {
                        dependencies: {
                            mode: "static",
                        },
                    },
                },
                exclusions: {
                    title: i18next.t("modals:newPolicyCommand.complexCommand.setupEthernetProxy.exclusions.title"),
                    type: "string",
                    options: {
                        dependencies: {
                            mode: "static",
                        },
                    },
                },
            },
            required: ["mode", "host", "port", "pac", "exclusions"],
        },
    },
    {
        name: "shutdownDevice",
        template: {
            command: "shutdownDevice",
            caption: i18next.t("modals:newPolicyCommand.command.shutdown.caption"),
        },
        schema: {
            title: i18next.t("modals:newPolicyCommand.command.shutdown.caption"),
            description: i18next.t("modals:newPolicyCommand.command.shutdown.description"),
            type: "object",
            options: {
                compact: "true",
                warning: i18next.t("modals:newPolicyCommand.command.shutdown.warning"),
                disable_properties: "true",
            },
        },
    },
    {
        name: "startActivity",
        schema: {
            title: i18next.t("modals:newPolicyCommand.complexCommand.startActivity.caption"),
            description: i18next.t("modals:newPolicyCommand.complexCommand.startActivity.description"),
            type: "object",
            options: {
                compact: "true",
                disable_properties: "false",
            },
            properties: {
                intent: parameterSchemas.intent,
            },
            required: ["intent"],
        },
    },
    {
        name: "startExecutable",
        schema: {
            title: i18next.t("modals:newPolicyCommand.complexCommand.startExecutable.caption"),
            description: i18next.t("modals:newPolicyCommand.complexCommand.startExecutable.description"),
            type: "object",
            options: {
                compact: "true",
                disable_properties: "true",
            },
            properties: {
                executable: {
                    type: "string",
                    title: i18next.t("modals:newPolicyCommand.complexCommand.startExecutable.executable.title"),
                    minLength: 2,
                    options: {
                        inputAttributes: {
                            placeholder: i18next.t(
                                "modals:newPolicyCommand.complexCommand.startExecutable.executable.placeholder",
                            ),
                        },
                    },
                },
            },
            required: ["executable"],
        },
    },
    {
        name: "startService",
        schema: {
            title: i18next.t("modals:newPolicyCommand.complexCommand.startService.caption"),
            description: i18next.t("modals:newPolicyCommand.complexCommand.startService.description"),
            type: "object",
            options: {
                compact: "true",
                disable_properties: "false",
            },
            properties: {
                intent: parameterSchemas.intent,
            },
            required: ["intent"],
        },
    },
    {
        name: "startPackage",
        schema: {
            title: i18next.t("modals:newPolicyCommand.complexCommand.startPackage.caption"),
            description: i18next.t("modals:newPolicyCommand.complexCommand.startPackage.description"),
            type: "object",
            options: {
                compact: "true",
                disable_properties: "true",
            },
            properties: {
                package: {
                    packageType: PackageTypes.LAUNCHABLE,
                    title: i18next.t("modals:newPolicyCommand.complexCommand.startPackage.package.title"),
                    type: "string",
                    enum: [],
                    default: "",
                },
            },
            required: ["package"],
        },
    },
    {
        name: "stopPackage",
        schema: {
            title: i18next.t("modals:newPolicyCommand.complexCommand.stopPackage.caption"),
            description: i18next.t("modals:newPolicyCommand.complexCommand.stopPackage.description"),
            type: "object",
            options: {
                compact: "true",
                disable_properties: "true",
            },
            properties: {
                package: {
                    packageType: PackageTypes.LAUNCHABLE,
                    title: i18next.t("modals:newPolicyCommand.complexCommand.stopPackage.package.title"),
                    type: "string",
                    enum: [],
                    default: "",
                },
            },
            required: ["package"],
        },
    },
    {
        name: "uninstallPackage",
        schema: {
            title: i18next.t("modals:newPolicyCommand.complexCommand.uninstallPackage.caption"),
            description: i18next.t("modals:newPolicyCommand.complexCommand.uninstallPackage.description"),
            type: "object",
            options: {
                compact: "true",
                disable_properties: "true",
            },
            properties: {
                package: {
                    packageType: PackageTypes.USER,
                    title: i18next.t("modals:newPolicyCommand.complexCommand.uninstallPackage.package.title"),
                    type: "string",
                    enum: [],
                    default: "",
                },
                version: parameterSchemas.version,
            },
            required: ["package", "version"],
        },
    },
    {
        name: "wipeUserdata",
        schema: {
            title: i18next.t("modals:newPolicyCommand.complexCommand.wipeUserdata.caption"),
            description: i18next.t("modals:newPolicyCommand.complexCommand.wipeUserdata.description"),
            type: "object",
            options: {
                compact: "true",
                disable_properties: "true",
            },
        },
    },
    {
        name: "writeFile",
        schema: {
            title: i18next.t("modals:newPolicyCommand.complexCommand.writeFile.caption"),
            description: i18next.t("modals:newPolicyCommand.complexCommand.writeFile.description"),
            type: "object",
            options: {
                compact: "true",
                disable_properties: "true",
            },
            properties: {
                path: {
                    title: i18next.t("modals:newPolicyCommand.complexCommand.writeFile.path.title"),
                    type: "string",
                    minLength: 2,
                    options: {
                        inputAttributes: {
                            placeholder: i18next.t("modals:newPolicyCommand.complexCommand.writeFile.path.placeholder"),
                        },
                    },
                },
                content: {
                    type: "string",
                    title: i18next.t("modals:newPolicyCommand.complexCommand.writeFile.content.title"),
                    options: {
                        inputAttributes: {
                            placeholder: i18next.t("modals:newPolicyCommand.complexCommand.writeFile.content.placeholder"),
                        },
                    },
                },
            },
            required: ["path", "content"],
        },
    },
];

/**
 *  Basic schema for the raw JSON editor.
 */
export const rawSchema = {
    title: "JSON Editor",
    type: "object",
    default: {
        command: "command name",
        caption: "caption name",
        parameter: "example",
    },
};
